import AssignUserToGroupForm from "@/components/AssignUserToGroupForm";

export default function AssignUserToGroupPage() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Assign User to Group</h1>
      <AssignUserToGroupForm />
    </div>
  );
}
